import React, { useState } from 'react';
import { Share2, Copy, Check, X, ExternalLink } from 'lucide-react';
import './ShareModal.css';

const ShareModal = ({ isOpen, onClose, shopId, generateShareLink }) => {
  const [shareLink, setShareLink] = useState('');
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleGenerateLink = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await generateShareLink(shopId);
      const token = response.data.token;
      const baseUrl = window.location.origin;
      const fullUrl = `${baseUrl}/shared/${token}`;
      setShareLink(fullUrl);
    } catch (err) {
      console.error('Error generating share link:', err);
      setError('Failed to generate share link. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(shareLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="share-modal-overlay" onClick={onClose}>
      <div className="share-modal-content" onClick={e => e.stopPropagation()}>
        <button className="share-modal-close" onClick={onClose}>
          <X size={20} />
        </button>

        <div className="share-modal-header">
          <div className="share-icon-wrapper">
            <Share2 size={24} className="share-icon" />
          </div>
          <h2>Share Dashboard</h2>
          <p>Generate a public link to share this shop's dashboard with others.</p>
        </div>

        <div className="share-modal-body">
          {!shareLink ? (
            <button 
              className="generate-btn" 
              onClick={handleGenerateLink}
              disabled={loading}
            >
              {loading ? 'Generating...' : 'Create Shareable Link'}
            </button>
          ) : (
            <div className="link-display-area">
              <div className="link-input-wrapper">
                <input 
                  type="text" 
                  readOnly 
                  value={shareLink} 
                  className="share-link-input"
                />
                <button className="copy-btn" onClick={handleCopy}>
                  {copied ? <Check size={18} /> : <Copy size={18} />}
                </button>
              </div>
              <p className="share-hint">
                Anyone with this link can view the dashboard without logging in.
              </p>
              <a 
                href={shareLink} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="preview-link"
              >
                Preview Link <ExternalLink size={14} />
              </a>
            </div>
          )}
          {error && <p className="share-error">{error}</p>}
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
